"use client"

import React, { useEffect, useState } from 'react'
import { ImageUploadItem } from './ImageUploadItem'
import ImageList from '../imageGeneration/ImageList'
import { ColorType } from '@/utils/APIRouteTypes'
import { useGeneratedImages } from '@/contexts/GeneratedImagesProvider'

type Props = {
    selectedImages: string[]
    handlePromptImageClick: (src: string) => void
}

export default function ImageUploader(props: Props) {
    const [generatedImages, setGeneratedImages] = useGeneratedImages()
    return (
        <div>
            <ImageUploadItem />

            <div className=' mt-4'>
                <h2 className='text-2xl'>Uploaded Images</h2>
            </div>

            <ImageList images={generatedImages.map(x => ({ src: x.src, bgMode: x.color }))} selectedImages={props.selectedImages} onImageClick={props.handlePromptImageClick} />
        </div>
    )
}
